import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const AdminProductsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        {t('navigation.products')} - Admin
      </Typography>
      <Typography variant="body1">
        Product catalog management and sync monitoring will be implemented here.
      </Typography>
    </Box>
  );
};

export default AdminProductsPage;